import Lenis from 'lenis';

/**
 * LpSmoothScroll
 * ページ全体に慣性スクロールを掛ける（Lenis）。LP専用で、本体サイトには入れない。
 *
 * - `prefers-reduced-motion` では**初期化しない**（素のスクロールに任せる）。
 * - rAFは自前で回し、**タブ非表示の間は止める**（見えていない間に回し続けない）。
 * - ページ内アンカーはLenis経由で送る。そうしないと慣性と競合して着地位置がずれる。
 * - Lenisは実際にドキュメントをスクロールするため、IntersectionObserver（リビール・
 *   背景canvas・スライダーの停止判定）はそのまま効く。
 * - 内側で独自にスクロールさせたい箇所（横スクロールする比較表など）には
 *   マークアップ側に `data-lenis-prevent` を付ける。
 */

const LERP = 0.1;

export default class LpSmoothScroll {
  constructor() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.lenis = new Lenis({
      lerp: LERP,
      autoRaf: false, // 停止制御を自前で持つため、Lenis側のrAFは使わない
    });

    this.onFrame = this.onFrame.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onAnchorClick = this.onAnchorClick.bind(this);

    this.rafId = 0;
    this.start();

    document.addEventListener('visibilitychange', this.onVisibilityChange);
    document.addEventListener('click', this.onAnchorClick);
  }

  /**
   * @param {number} time
   */
  onFrame(time) {
    this.lenis.raf(time);
    this.rafId = window.requestAnimationFrame(this.onFrame);
  }

  start() {
    if (this.rafId) {
      return;
    }
    this.rafId = window.requestAnimationFrame(this.onFrame);
  }

  stop() {
    if (!this.rafId) {
      return;
    }
    window.cancelAnimationFrame(this.rafId);
    this.rafId = 0;
  }

  onVisibilityChange() {
    if (document.hidden) {
      this.stop();
    } else {
      this.start();
    }
  }

  /**
   * ページ内リンクをLenisへ流す（委譲でひとつだけ張る＝後から増えたリンクにも効く）
   * @param {MouseEvent} event
   */
  onAnchorClick(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    const link = event.target.closest('a[href^="#"]');
    if (!link) {
      return;
    }
    const hash = link.getAttribute('href');
    if (hash === '#') {
      return;
    }
    const target = document.querySelector(hash);
    if (!target) {
      return;
    }
    event.preventDefault();
    this.lenis.scrollTo(target);
  }

  destroy() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    document.removeEventListener('click', this.onAnchorClick);
    if (this.lenis) {
      this.lenis.destroy();
      this.lenis = null;
    }
  }
}
